<script>
    import {router} from '../lib/Router/Router.svelte';
    import A from "../lib/Router/A.svelte";
    import AppIcon from "./icons/AppIcon.svelte";

    export let breadcrumb = [];
</script>


<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        {#each breadcrumb as item}
            <li class="breadcrumb-item"><A href="{ item.link }"><AppIcon icon="chevron-left" strokeWidth="2" cssClass="me-1"/>{ item.name }</A></li>
        {/each}
    </ol>
</nav>

<style>
    .breadcrumb-item {
        font-size: 0.94rem;
    }

    :global(.breadcrumb-item a) {
        display: flex;
        background: #e3e6eb;
        padding: 0 10px 0 3px;
    border-radius: 5px;
    }
</style>